import adigital from 'src/static/svg/powered/adigital.svg'
import icex from 'src/static/svg/powered/gobvice-icex_minis_europa_blanco.svg'
import eoi from 'src/static/svg/powered/eoi-w.svg'
import fse from 'src/static/svg/powered/fse.svg'
import ue from 'src/static/svg/powered/ES_Co-fundedbytheEU_RGB_WHITE Outline.svg'

export default {adigital, eoi, icex, fse, ue}
